module.exports = __webpack_public_path__ + "static/media/10.b74ccfa1.png";